;(function () {
  'use strict'

  angular.module('contrast.licenses-activity-series').factory(
    'chartProtectUsageBuilderService',
    // eslint-disable-next-line angular/di-unused
    function chartProtectUsageBuilderServiceFactory(
      csTemplates,
      $translate,
      $q,
      _,
      ServiceUtils,
      Highcharts,
      highchartsSeriesBuilderService,
      highchartsColorService,
      highchartsTooltipBuilderService,
      HIGHCHARTS_COLORS,
      HIGHCHARTS_Z_INDEX,
      CHART_SERIES_ID,
      CHART_ID,
      CHART_EVENTS,
      CHART_CONFIG_ID
    ) {
      'ngInject'

      return {
        buildProtectUsageChart: buildProtectUsageChart
      }

      function buildProtectUsageChart(
        scope,
        element,
        parentChart,
        width,
        config,
        isUsageHours
      ) {
        var tplConfig = {
          xAxisLabelTpl:
            'components/licenses-activity-series/x-axis-label.tpl.html',
          plotLineLabelTpl:
            'components/licenses-activity-series/plot-line-label.tpl.html',
          plotLineInvisibleLabelTpl:
            'components/licenses-activity-series/plot-line-invisible-label.tpl.html',
          gridLineLabelTpl:
            'components/licenses-activity-series/y-scale-line.tpl.html',
          agentUsageTooltipTpl:
            'components/licenses-activity-series/agent-usage-tooltip.tpl.html',
          usageHoursTooltipTpl:
            'components/licenses-activity-series/usage-hours-tooltip.tpl.html',
          drilldownTooltipTpl:
            'components/licenses-activity-series/drilldown-tooltip.tpl.html'
        }

        var tplPromises = _.mapValues(tplConfig, function (tplURL) {
          return csTemplates.load(tplURL)
        })

        return $q
          .all(tplPromises)
          .then(function (templates) {
            if (isUsageHours) {
              return _buildUsageHoursChart(
                scope,
                element,
                parentChart,
                width,
                config,
                templates.usageHoursTooltipTpl,
                templates.drilldownTooltipTpl,
                templates.gridLineLabelTpl
              )
            } else {
              return _buildAgentUsageChart(
                scope,
                element,
                parentChart,
                width,
                config,
                templates.agentUsageTooltipTpl,
                templates.drilldownTooltipTpl,
                templates.plotLineLabelTpl,
                templates.plotLineInvisibleLabelTpl
              )
            }
          })
          .catch(ServiceUtils.handleError)
      }

      function _buildAgentUsageChart(
        scope,
        element,
        parentChart,
        width,
        config,
        tooltipTpl,
        drilldownTooltipTpl,
        plotLineLabelTpl,
        plotLineInvisibleLabelTpl
      ) {
        var seriesAnimationCompleted = 0

        var plotLines = _buildPlotLines(
          config.yAxis.plotLinesConfig,
          plotLineLabelTpl,
          plotLineInvisibleLabelTpl
        )

        var series = _buildAgentUsageSeries(
          scope,
          config.yAxis.seriesConfig,
          config.xAxis.values,
          config.xAxis.startValue,
          config.data.totalProtectLicenses
        )

        var tooltipConfig = highchartsTooltipBuilderService.buildTooltipConfig()
        _addAgentUsageTooltipFormatter(
          tooltipConfig,
          tooltipTpl,
          drilldownTooltipTpl,
          CHART_SERIES_ID.USAGE_HOURS_BACKGROUND,
          config.data.totalProtectLicenses
        )

        var options = {
          firstAnimationFinished: false,
          /* Start Block of Chart Configurations*/
          chart: {
            width: width
          },
          plotOptions: {
            series: {
              events: {
                afterAnimate: function () {
                  if (!this.chart.firstAnimationFinished) {
                    seriesAnimationCompleted++
                    if (seriesAnimationCompleted == this.chart.series.length) {
                      this.chart.firstAnimationFinished = true
                      this.chart.hideLoading()
                    }
                  }
                }
              }
            }
          },
          tooltip: tooltipConfig,
          /* End Block of Chart Configurations*/

          /* Start Block of Axis Data Initialization*/
          xAxis: {
            tickPositions: config.xAxis.values,
            labels: {
              format: '{value:' + config.xAxis.format + '}'
            }
          },
          yAxis: {
            min: -0.2,
            startOnTick: false,
            max: Math.max(
              config.data.maxAgentUsage + 1,
              config.data.totalProtectLicenses + 1
            ),
            plotLines: plotLines
          },
          series: series
          /* End Block of Axis Data Initialization*/
        }

        parentChart = new Highcharts.Chart(element, options)
        parentChart.showLoading()

        return parentChart
      }

      function _buildUsageHoursChart(
        scope,
        element,
        parentChart,
        width,
        config,
        tooltipTpl,
        drilldownTooltipTpl,
        yScaleLineTpl
      ) {
        var seriesAnimationCompleted = 0

        var series = _buildUsageHoursSeries(
          scope,
          config.yAxis.seriesConfig,
          config.xAxis.values
        )

        var minYAllowedValue = 0
        var maxYAllowedValue = config.data.maxUsageHours + 1

        var tooltipConfig = highchartsTooltipBuilderService.buildTooltipConfig()
        _addUsageHoursTooltipFormatter(
          tooltipConfig,
          tooltipTpl,
          drilldownTooltipTpl,
          CHART_SERIES_ID.AGENT_USAGE_AREA_BACKGROUND
        )

        var options = {
          firstAnimationFinished: false,
          /* Start Block of Chart Configurations*/
          chart: {
            width: width
          },
          plotOptions: {
            series: {
              events: {
                afterAnimate: function () {
                  if (!this.chart.firstAnimationFinished) {
                    seriesAnimationCompleted++
                    if (seriesAnimationCompleted == this.chart.series.length) {
                      this.chart.firstAnimationFinished = true
                      this.chart.hideLoading()
                    }
                  }
                }
              }
            }
          },
          tooltip: tooltipConfig,
          /* End Block of Chart Configurations*/

          /* Start Block of Axis Data Initialization*/
          xAxis: {
            tickPositions: config.xAxis.values,
            labels: {
              format: '{value:' + config.xAxis.format + '}'
            }
          },
          yAxis: {
            min: -0.2,
            max: maxYAllowedValue,
            gridLineColor: HIGHCHARTS_COLORS.Y_AXIS_SCALE,
            gridLineDashStyle: 'dash',
            startOnTick: false,
            endOnTick: false,
            tickPositioner: function () {
              return _.filter(this.tickPositions, function (tickValue) {
                return (
                  tickValue > minYAllowedValue && tickValue < maxYAllowedValue
                )
              })
            },
            labels: {
              enabled: true,
              step: 2,
              style: {
                color: HIGHCHARTS_COLORS.Y_AXIS_SCALE
              },
              x: -4,
              formatter: function () {
                return csTemplates.interpolate(yScaleLineTpl, {
                  yValue: this.value
                })
              }
            }
          },
          series: series
          /* End Block of Axis Data Initialization*/
        }
        parentChart = new Highcharts.Chart(element, options)
        parentChart.showLoading()

        return parentChart
      }

      function _buildPlotLines(
        plotLinesConfigs,
        plotLineLabelTpl,
        plotLineInvisibleLabelTpl
      ) {
        var plotLines = []

        angular.forEach(plotLinesConfigs, function (config) {
          plotLines.push(
            highchartsSeriesBuilderService.buildPlotLine(
              config.value,
              config.color,
              config.tooltip.message,
              plotLineLabelTpl
            )
          )
          plotLines.push(
            highchartsSeriesBuilderService.buildInvisiblePlotLine(
              config.value,
              config.color,
              config.tooltip.message,
              plotLineInvisibleLabelTpl
            )
          )
        })
        return plotLines
      }

      function _buildAgentUsageSeries(
        scope,
        dataConfig,
        xAxisValues,
        startXPoint,
        totalProtectLicenses
      ) {
        var series = []
        angular.forEach(dataConfig, function (config) {
          //build the Highcharts Series depending on the config type
          switch (config.id) {
            //Usage Hours chart needs a special chart configuration
            case CHART_CONFIG_ID.PROTECT_USAGE_HOURS_SERIES_CONFIG:
              _buildBackgroundUsageHoursSeries(
                scope,
                series,
                xAxisValues,
                config
              )
              break
            case CHART_CONFIG_ID.PROTECT_AGENT_USAGE_SERIES_CONFIG:
            default:
              _buildForegroundAgentUsageSeries(series, xAxisValues, config)
          }
        })

        // add an extra Series element (an invisible point) in order to adjust the Y Axis size and be sure about always displaying the Tallest Plot Line
        series.push(
          highchartsSeriesBuilderService.buildSinglePointScatterSeries(
            startXPoint,
            totalProtectLicenses
          )
        )

        return series
      }

      function _buildUsageHoursSeries(scope, dataConfig, xAxisValues) {
        var series = []
        angular.forEach(dataConfig, function (config) {
          //build the Highcharts Series depending on the config type
          switch (config.id) {
            //Usage Hours chart needs a special chart configuration
            case CHART_CONFIG_ID.PROTECT_USAGE_HOURS_SERIES_CONFIG:
              _buildForegroundUsageHoursSeries(series, xAxisValues, config)
              break
            case CHART_CONFIG_ID.PROTECT_AGENT_USAGE_SERIES_CONFIG:
            default:
              _buildBackgroundAgentUsageSeries(
                scope,
                series,
                xAxisValues,
                config
              )
          }
        })
        return series
      }

      function _buildBackgroundUsageHoursSeries(
        scope,
        seriesList,
        xAxisValues,
        config
      ) {
        var data = _.map(xAxisValues, function (xAxisValue, index) {
          return [xAxisValue, config.values[index]]
        })

        // render a column chart in the background
        var columnSeries =
          highchartsSeriesBuilderService.buildBackgroundColumnSeries(
            CHART_SERIES_ID.USAGE_HOURS_BACKGROUND,
            data,
            config.tooltip.message,
            HIGHCHARTS_COLORS.DISABLED_SERIES,
            config.color,
            HIGHCHARTS_Z_INDEX.MIDDLE,
            0.35,
            0.1,
            config
          )

        // add drilldown configuration
        _addUsageHoursSeriesDrilldownConfig(
          scope,
          columnSeries,
          config.drilldown,
          CHART_SERIES_ID.USAGE_HOURS_BACKGROUND
        )

        seriesList.push(columnSeries)
      }

      function _buildForegroundAgentUsageSeries(
        seriesList,
        xAxisValues,
        config
      ) {
        var data = _.map(xAxisValues, function (xAxisValue, index) {
          return [xAxisValue, config.values[index]]
        })

        // render the trend line
        var scatterSeries = highchartsSeriesBuilderService.buildScatterSeries(
          CHART_SERIES_ID.AGENT_USAGE,
          data,
          config.tooltip.message,
          config.color,
          HIGHCHARTS_Z_INDEX.TOP,
          config
        )
        // render the gradient area
        var areaSeries = highchartsSeriesBuilderService.buildAreaSeries(
          CHART_SERIES_ID.AGENT_USAGE_AREA,
          data,
          config.tooltip.message,
          config.color,
          HIGHCHARTS_Z_INDEX.BOTTOM,
          0.1,
          0,
          config
        )
        // remove all the events in the gradient area
        highchartsSeriesBuilderService.disableSeriesTrackingConfig(areaSeries)

        seriesList.push(scatterSeries, areaSeries)
      }

      function _buildForegroundUsageHoursSeries(
        seriesList,
        xAxisValues,
        config
      ) {
        var data = _.map(xAxisValues, function (xAxisValue, index) {
          return {
            x: xAxisValue,
            y: config.values[index]
          }
        })

        // render a column chart in the background
        var columnSeries =
          highchartsSeriesBuilderService.buildColorByPointColumnSeries(
            CHART_SERIES_ID.USAGE_HOURS,
            data,
            config.tooltip.message,
            config.color,
            HIGHCHARTS_Z_INDEX.MIDDLE,
            1,
            0.4,
            config.maxValue,
            config
          )

        seriesList.push(columnSeries)
      }

      function _buildBackgroundAgentUsageSeries(
        scope,
        seriesList,
        xAxisValues,
        config
      ) {
        var data = _.map(xAxisValues, function (xAxisValue, index) {
          return [xAxisValue, config.values[index]]
        })

        // render the gradient area
        var areaSeries =
          highchartsSeriesBuilderService.buildBackgroundAreaSeries(
            CHART_SERIES_ID.AGENT_USAGE_AREA_BACKGROUND,
            data,
            config.tooltip.message,
            HIGHCHARTS_COLORS.DISABLED_SERIES,
            config.color,
            HIGHCHARTS_Z_INDEX.BOTTOM,
            0.1,
            0,
            config
          )
        // add drilldown configuration
        _addAgentUsageSeriesDrilldownConfig(
          scope,
          areaSeries,
          config.drilldown,
          CHART_SERIES_ID.AGENT_USAGE_AREA_BACKGROUND
        )

        seriesList.push(areaSeries)
      }

      function _addUsageHoursSeriesDrilldownConfig(
        scope,
        series,
        drilldownConfig,
        seriesId
      ) {
        angular.extend(series, {
          tooltip: {
            followPointer: true,
            followTouchMove: true
          },
          cursor: 'pointer',
          stickyTracking: false,
          lineWidth: 0,
          states: {
            hover: {
              enabled: false
            }
          },
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: false
              }
            }
          },
          events: {
            mouseOver: function () {
              highchartsColorService.setDisabledSeriesColor(this.chart.series)
              highchartsColorService.setHoverSeriesColor([
                this.chart.get(seriesId)
              ])
              //redraw after updating series info (colors)
              this.chart.redraw()
            },
            mouseOut: function () {
              highchartsColorService.setDefaultSeriesColor(this.chart.series)
              //redraw after updating series info (colors)
              this.chart.redraw()
            },
            click: function () {
              scope.$emit(CHART_EVENTS.DRILLDOWN_AGENT_USAGE_TO_USAGE_HOURS)
            }
          }
        })
      }

      function _addAgentUsageSeriesDrilldownConfig(
        scope,
        series,
        drilldownConfig,
        seriesId
      ) {
        angular.extend(series, {
          tooltip: {
            followPointer: true,
            followTouchMove: true
          },
          cursor: 'pointer',
          trackByArea: true,
          stickyTracking: false,
          events: {
            mouseOver: function () {
              highchartsColorService.setDisabledSeriesColor(this.chart.series)
              highchartsColorService.setHoverSeriesColor([
                this.chart.get(seriesId)
              ])
              //redraw after updating series info (colors)
              this.chart.redraw()
            },
            mouseOut: function () {
              highchartsColorService.setDefaultSeriesColor(this.chart.series)
              //redraw after updating series info (colors)
              this.chart.redraw()
            },
            click: function () {
              scope.$emit(CHART_EVENTS.DRILLDOWN_USAGE_HOURS_TO_AGENT_USAGE)
            }
          }
        })
      }

      function _addAgentUsageTooltipFormatter(
        tooltipConfig,
        tooltipTpl,
        drilldownTooltipTpl,
        drilldownSeriesId,
        totalProtectLicenses
      ) {
        highchartsTooltipBuilderService.setTooltipBg(
          tooltipConfig,
          drilldownSeriesId,
          HIGHCHARTS_COLORS.PROTECT_USAGE_TOOLTIP_BACKGROUND
        )

        tooltipConfig.formatter = function () {
          if (this.series.options.id === drilldownSeriesId) {
            return csTemplates.interpolate(drilldownTooltipTpl, {
              message: this.series.options.rawConfig.drilldown.tooltip.message
            })
          } else {
            return csTemplates.interpolate(tooltipTpl, {
              message: this.series.options.rawConfig.tooltip.message,
              yValue: this.point.y,
              remainingLicenses: totalProtectLicenses - this.point.y
            })
          }
        }
      }

      function _addUsageHoursTooltipFormatter(
        tooltipConfig,
        tooltipTpl,
        drilldownTooltipTpl,
        drilldownSeriesId
      ) {
        highchartsTooltipBuilderService.setTooltipBg(
          tooltipConfig,
          drilldownSeriesId,
          HIGHCHARTS_COLORS.PROTECT_USAGE_TOOLTIP_BACKGROUND
        )

        tooltipConfig.formatter = function () {
          if (this.series.options.id === drilldownSeriesId) {
            return csTemplates.interpolate(drilldownTooltipTpl, {
              message: this.series.options.rawConfig.drilldown.tooltip.message
            })
          } else {
            return csTemplates.interpolate(tooltipTpl, {
              message: this.series.options.rawConfig.tooltip.message,
              yValue: this.point.y
            })
          }
        }

        tooltipConfig.positioner = function (boxWidth, boxHeight, point) {
          var ret = _getPosition(
            boxWidth,
            boxHeight,
            point,
            this.chart,
            this.distance,
            this.followPointer,
            this.len
          )
          if (point.plotY < ret.y) {
            var tooltipTopMargin = 20
            ret.y = ret.y + tooltipTopMargin // add extra tooltip distance (margin) when tooltip is displayed below the point
          }
          return ret
        }
      }

      /* Tooltips background
       * Wrapping Tooltip.refresh() method in order to change the tooltip's background according to the point's series color.
       * Reference: https://stackoverflow.com/questions/42772038/highcharts-tooltip-background-according-to-line-without-setting-backgroundcolor
       */
      function _getPosition(
        boxWidth,
        boxHeight,
        point,
        hChart,
        hDistance,
        hFollowPointer,
        hLen
      ) {
        var chart = hChart,
          distance = hDistance,
          ret = {},
          // Don't use h if chart isn't inverted (#7242)
          h = (chart.inverted && point.h) || 0, // #4117
          swapped,
          first = [
            'y',
            chart.chartHeight,
            boxHeight,
            point.plotY + chart.plotTop,
            chart.plotTop,
            chart.plotTop + chart.plotHeight
          ],
          second = [
            'x',
            chart.chartWidth,
            boxWidth,
            point.plotX + chart.plotLeft,
            chart.plotLeft,
            chart.plotLeft + chart.plotWidth
          ],
          // The far side is right or bottom
          preferFarSide =
            !hFollowPointer &&
            Highcharts.pick(
              point.ttBelow,
              !chart.inverted === !!point.negative
            ), // #4984
          /**
           * Handle the preferred dimension. When the preferred dimension is
           * tooltip on top or bottom of the point, it will look for space
           * there.
           */
          firstDimension = function (
            dim,
            outerSize,
            innerSize,
            point,
            min,
            max
          ) {
            var roomLeft = innerSize < point - distance,
              roomRight = point + distance + innerSize < outerSize,
              alignedLeft = point - distance - innerSize,
              alignedRight = point + distance

            if (preferFarSide && roomRight) {
              ret[dim] = alignedRight
            } else if (!preferFarSide && roomLeft) {
              ret[dim] = alignedLeft
            } else if (roomLeft) {
              ret[dim] = Math.min(
                max - innerSize,
                alignedLeft - h < 0 ? alignedLeft : alignedLeft - h
              )
            } else if (roomRight) {
              ret[dim] = Math.max(
                min,
                alignedRight + h + innerSize > outerSize
                  ? alignedRight
                  : alignedRight + h
              )
            } else {
              return false
            }
          },
          /**
           * Handle the secondary dimension. If the preferred dimension is
           * tooltip on top or bottom of the point, the second dimension is to
           * align the tooltip above the point, trying to align center but
           * allowing left or right align within the chart box.
           */
          secondDimension = function (dim, outerSize, innerSize, point) {
            var retVal

            // Too close to the edge, return false and swap dimensions
            if (point < distance || point > outerSize - distance) {
              retVal = false
              // Align left/top
            } else if (point < innerSize / 2) {
              ret[dim] = 1
              // Align right/bottom
            } else if (point > outerSize - innerSize / 2) {
              ret[dim] = outerSize - innerSize - 2
              // Align center
            } else {
              ret[dim] = point - innerSize / 2
            }
            return retVal
          },
          /**
           * Swap the dimensions
           */
          swap = function (count) {
            var temp = first
            first = second
            second = temp
            swapped = count
          },
          run = function () {
            if (firstDimension.apply(0, first) !== false) {
              if (secondDimension.apply(0, second) === false && !swapped) {
                swap(true)
                run()
              }
            } else if (!swapped) {
              swap(true)
              run()
            } else {
              ret.x = ret.y = 0
            }
          }

        // Under these conditions, prefer the tooltip on the side of the point
        if (chart.inverted || hLen > 1) {
          swap()
        }
        run()
        return ret
      }
    }
  )
})()
